import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Row,
  Select,
  Space,
  Table,
} from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectCredentials,
  selectInsuranceArray, selectRole,
  selectStationCategory,
  selectUserId
} from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  getDateRange,
  TJFXTime,
} from '../../../compnents/form/DateSelect'
import {
  getOutpatientDepartment,
} from '../../registration/register/registerSlice'
import { getTcmRecipeSummaryAsync } from './recipeQuery'
import { getSFDoctorListAsync } from '../../sales/DoctorAccont/doctorAuditSlice'
import styles from './recipeQueryList.module.css'

export const TcmRecipeSummary = (props:{
  activeKey?: any
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [loading, setLoading] = useState(false)

  const [timeHead, timeTail] = getDateRange(DateRangeType.ThisMonth)

  const [doctors, setDoctors] = useState<any[]>([])

  const insuranceArray = useSelector(selectInsuranceArray)

  const [summaryData, setSummaryData] = useState<any[]>([])

  const credentials: any = useSelector(selectCredentials)

  const stationCategory = useSelector(selectStationCategory)

  const userId = useSelector(selectUserId)
  const role = useSelector(selectRole)


  const [rankDisabled,setRankDisabled] = useState(true) // 是否禁止查看其他医生，默认禁止，管理员和非医生开放

  useEffect(() => {
    if(role == undefined || stationCategory == undefined){
      return;
    }
    if(role == 1 ){
      setRankDisabled(false)
    }else{
      if(stationCategory != 1){
        setRankDisabled(false)
      }
    }
  }, [role,stationCategory])


  const columns = [
    {
      title: '序号',
      dataIndex: 'index',
      key: 'index',
      width: 80,
      align: 'center' as const,
    },
    {
      title: '检查内容',
      dataIndex: 'name',
      key: 'name',
      align: 'left' as const,
    },
    {
      title: '结果',
      dataIndex: 'value',
      key: 'value',
      width: 200,
      align: 'center' as const,
    },
  ]

  const fmt = (v: any) => (!v || v === '0' || v === '0.00') ? '-' : v

  const buildTableData = (res: any) => {
    return [
      { index: 1, name: '帖均费用（元）', value: fmt(res?.thePostIsCostly), key: '1' },
      { index: 2, name: '均帖味数（味）', value: fmt(res?.avgTasteCount), key: '2' },
      { index: 3, name: '每帖费用小于等于30元的处方数（张）', value: fmt(res?.costLess30Count), key: '3' },
      { index: 4, name: '每帖费用大于30元小于等于40元的处方数（张）', value: fmt(res?.costBetween30And40Count), key: '4' },
      { index: 5, name: '每帖费用大于40元小于等于50元的处方数（张）', value: fmt(res?.costBetween40And50Count), key: '5' },
      { index: 6, name: '每帖费用大于50元的处方数（张）,规定病种除外', value: fmt(res?.costOver50Count), key: '6' },
      { index: 7, name: '总处方数（张）', value: fmt(res?.totalRecipeCount), key: '7' },
      { index: 8, name: '总帖数（张）', value: fmt(res?.totalPostCount), key: '8' },
      { index: 9, name: '处方总金额（元）', value: fmt(res?.totalAmount), key: '9' },
      { index: 10, name: '味数超过20味的处方数', value: fmt(res?.tasteOver20Count), key: '10' },
      { index: 11, name: '味数超过25味的处方数', value: fmt(res?.tasteOver25Count), key: '11' },
    ]
  }

  const fetchData = (values?: any) => {
    setLoading(true)
    console.log('queryParams', stationCategory,userId)
    const queryParams = {
      doctorId: stationCategory == 1 ? userId : values?.doctorId,
      insuranceCode: values?.insuranceCode || undefined,
      treatmentCategory: values?.treatmentCategory === 99 ? undefined : values?.treatmentCategory,
      timeHead: values?.timeHead || timeHead,
      timeTail: values?.timeTail || timeTail,
    }
    dispatch(getTcmRecipeSummaryAsync(queryParams))
      .then(unwrapResult)
      .then((res: any) => {
        setSummaryData(buildTableData(res))
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    if(props?.activeKey == 2) {
      dispatch(getOutpatientDepartment())
      dispatch(getSFDoctorListAsync())
          .then(unwrapResult)
          .then((v: any) => {
            setDoctors(v)
            if(stationCategory == 1){
              form.setFieldsValue({
                doctorId: Number(userId),
              })
            }
          })
      form.setFieldsValue({
        [DateRangeFieldName]: DateRangeType.ThisMonth,
        timeHead,
        timeTail,
        treatmentCategory: 99,
      })
      fetchData()
    }
  }, [props?.activeKey])

  return (
    <Col className={styles.main}>
      <Form
        form={form}
        onFinish={(values) => {
          if (!values?.timeHead && values?.[DateRangeFieldName] == 6) {
            return
          }
          fetchData(values)
        }}
      >
        <Row style={{ margin: '20px 0 10px 0' }}>
          <Space>
            <Form.Item noStyle name="doctorId">
                <Select
                    style={{ width: '8.25rem' }}
                    placeholder='医生列表'
                    allowClear
                    disabled={rankDisabled}
                    onChange={form.submit}
                >
                    {doctors.map((d: any) => (
                        <Select.Option key={d.id} value={d.id}>
                            {d.realname}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            {insuranceArray && insuranceArray.length !== 0 && (
              <Form.Item name='insuranceCode' noStyle>
                <Select
                  placeholder='险种类型'
                  style={{ width: '8rem' }}
                  allowClear
                  onChange={form.submit}
                >
                  <Select.Option value={''}>全部</Select.Option>
                  <Select.Option value={'ZIFEI'}>自费</Select.Option>
                  {insuranceArray.map((v) => (
                    <Select.Option value={v.insuranceCode} key={v.id}>
                      {v.insuranceName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            )}
            <Form.Item noStyle name="treatmentCategory">
              <Select
                style={{ width: '8rem' }}
                placeholder="医疗类别"
                allowClear
                onChange={form.submit}
              >
                <Select.Option value={99}>全部</Select.Option>
                <Select.Option value={0}>普通</Select.Option>
                <Select.Option value={1}>特病</Select.Option>
                <Select.Option value={2}>慢病</Select.Option>
              </Select>
            </Form.Item>
            <DateSelect
              style={{ width: '8rem' }}
              labelPrefix=""
              allowClear={false}
              namePrefix="time"
              options={TJFXTime}
              placeholder="日期范围-全部"
              initialValue={DateRangeType.Today}
              onChange={() => form.submit()}
            />
            <Button type="primary" htmlType="submit" loading={loading}>
              查询
            </Button>
          </Space>
        </Row>
      </Form>
      <Table
        style={{ height: '90%', overflowY: 'auto' }}
        loading={loading}
        columns={columns}
        dataSource={summaryData}
        pagination={false}
        bordered
        size="middle"
      />
    </Col>
  )
}
